import {z} from "zod";

export const accountStatusResponse = z.object({
    id: z.string(),
    active: z.boolean().default(true),
    verified: z.boolean().default(false),
    verified_id: z.string().uuid().nullable(),
    consent_data_privacy: z.boolean().default(false),
    consent_data_privacy_at: z.date(),
    updated_at: z.date(),
    created_at: z.date(),
});

export type AccountStatusResponse = z.infer<typeof accountStatusResponse>;

export const accountStatusEntityResponse = z.object({
    id: z.string(),
    active: z.boolean().default(true),
    verified: z.boolean().default(false),
    verified_id: z.string().uuid().nullable(),
    consent_data_privacy: z.boolean().default(false),
    consent_data_privacy_at: z.date(),
    updated_at: z.date(),
    created_at: z.date(),
});

export type AccountStatusEntityResponse = z.infer<typeof accountStatusEntityResponse>;

export const accountStatusByIdRequest = z.object({
    id: z.string().uuid(),
});

export type AccountStatusByIdRequest = z.infer<typeof accountStatusByIdRequest>;

export const accountStatusUpdateRequest = z.object({
    id: z.string().uuid(),
    data: z.object({
        active: z.boolean(),
    })
});

export type AccountStatusUpdateRequest = z.infer<typeof accountStatusUpdateRequest>;

export const accountStatusConsentUpdateRequest= z.object({
    id: z.string().uuid(),
    data: z.object({
        consent_data_privacy: z.boolean(),
        consent_data_privacy_at: z.date(),
    })
});

export type AccountStatusConsentUpdateRequest = z.infer<typeof accountStatusConsentUpdateRequest>;

export const accountStatusVerifiedUpdateRequest = z.object({
    id: z.string().uuid(),
    data: z.object({
        verified: z.boolean(),
        verified_id: z.string().uuid(),
    })
});

export type AccountStatusVerifiedUpdateRequest = z.infer<typeof accountStatusVerifiedUpdateRequest>;